import { Action } from '@ngrx/store';
import { List } from 'immutable';

import {
  OnlineResource,
  OnlineResourceGoogleBooks,
} from '®shared/bibliographic-resource';
import { PageableItems } from '®shared/reading-list/models';
import { QuickFilter } from '®shared/reading-list/quick-filters';
import { ResourceTypeFilter } from '®shared/reading-list/resource-type-filter';

export enum ListItemActionTypes {
  ITEMS_LOADED = '[List items] items loaded',
  ONLINE_RESOURCES_LOADED = '[List items] online resources loaded',
  REQUEST_GOOGLE_BOOKS = '[List items] request google books',
  EXPAND_ITEM = '[List items] Expand item',
  COLLAPSE_ITEM = '[List items] Collapse item',
  FILTER_ITEMS_BY_TEXT_FILTER = '[List items] Filter items by text filter',
  FILTER_ITEMS_BY_QUICK_FILTER = '[List items] Filter items by quick filter',
  FILTER_ITEMS_BY_RESOURCE_TYPE_FILTER = '[List items] Filter items by resource type filter',
}

export class ItemsLoadedAction implements Action {
  readonly type = ListItemActionTypes.ITEMS_LOADED;

  constructor(public payload: PageableItems) {}
}

export class OnlineResourcesLoadedAction implements Action {
  readonly type = ListItemActionTypes.ONLINE_RESOURCES_LOADED;

  constructor(public payload: List<OnlineResource>) {}
}

export class RequestGoogleBooksAction implements Action {
  readonly type = ListItemActionTypes.REQUEST_GOOGLE_BOOKS;

  constructor(public payload: List<OnlineResourceGoogleBooks>) {}
}

interface ToggleItemPayload {
  itemId: string;
}

export class ExpandItemAction implements Action {
  readonly type = ListItemActionTypes.EXPAND_ITEM;

  constructor(public payload: ToggleItemPayload) {}
}

export class CollapseItemAction implements Action {
  readonly type = ListItemActionTypes.COLLAPSE_ITEM;
}

interface TextFilterPayload {
  filterText: string;
}

export class FilterItemsByTextFilterAction implements Action {
  readonly type = ListItemActionTypes.FILTER_ITEMS_BY_TEXT_FILTER;

  constructor(public payload: TextFilterPayload) {}
}

interface QuickFilterPayload {
  quickFilter: QuickFilter;
}

interface ResourceTypeFilterPayload {
  resourceTypeFilter: ResourceTypeFilter;
}

export class FilterItemsByQuickFilterAction implements Action {
  readonly type = ListItemActionTypes.FILTER_ITEMS_BY_QUICK_FILTER;

  constructor(public payload: QuickFilterPayload) {}
}

export class FilterItemsByResourceTypeFilterAction implements Action {
  readonly type = ListItemActionTypes.FILTER_ITEMS_BY_RESOURCE_TYPE_FILTER;

  constructor(public payload: ResourceTypeFilterPayload) {}
}

export type ListItemActions =
  | ItemsLoadedAction
  | OnlineResourcesLoadedAction
  | RequestGoogleBooksAction
  | ExpandItemAction
  | CollapseItemAction
  | FilterItemsByTextFilterAction
  | FilterItemsByQuickFilterAction
  | FilterItemsByResourceTypeFilterAction;
